/**
 * Web replacement for the app's view-shot + CameraRoll save.
 * Rasterises a DOM node to PNG and hands it to the browser as a download —
 * no permission needed, unlike the Android gallery write it replaces.
 */
export async function saveNodeAsImage(node, filename = 'narayan-id-card.png') {
  if (!node) return { ok: false, error: 'Nothing to capture.' };
  try {
    const { default: html2canvas } = await import('html2canvas');
    const canvas = await html2canvas(node, {
      backgroundColor: null,
      scale: Math.min(3, window.devicePixelRatio * 2 || 2), // crisp on retina
      useCORS: true,
      logging: false,
    });

    const dataUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    return { ok: true, dataUrl };
  } catch (e) {
    return { ok: false, error: e?.message || 'Could not generate the image.' };
  }
}

/** Share text via the native share sheet, falling back to the clipboard. */
export async function shareText(text, title = 'Narayan') {
  try {
    if (navigator.share) {
      await navigator.share({ title, text });
      return { ok: true, shared: true };
    }
  } catch (e) {
    // User dismissed the share sheet — not an error worth surfacing.
    if (e?.name === 'AbortError') return { ok: true, cancelled: true };
  }
  try {
    await navigator.clipboard.writeText(text);
    return { ok: true, copied: true };
  } catch (e) {
    return { ok: false, error: 'Could not share or copy.' };
  }
}

const download = { saveNodeAsImage, shareText };
export default download;
